"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Text = _interopRequireDefault(require("../../Text"));

function DropdownLabelContent(a) {
  var b = a.label,
      c = a.disabled;
  return "string" == typeof b ? _react["default"].createElement(_Text["default"], {
    disabled: c,
    noMargin: !0,
    className: "dropdown-option__content__label"
  }, b) : b;
}

var _default = DropdownLabelContent;
exports["default"] = _default;